import {createAction} from '@reduxjs/toolkit'

export const HISTORY_BACK = 'HISTORY_BACK'
export const REFRESH_PAGE = 'REFRESH_PAGE'
export const REFRESH_PAGE_ONCE = 'REFRESH_PAGE_ONCE'
export const SCROLL_TO = 'SCROLL_TO'
export const SCROLL_TO_WINDOW_TOP = 'SCROLL_TO_WINDOW_TOP'
export const NAVIGATE_TO_SEARCH = 'NAVIGATE_TO_SEARCH'
export const CLEAR_REFRESHED_STATUS = 'CLEAR_REFRESHED_STATUS'
export const PP_LOADED = 'PP_LOADED'

type HistoryBackType = {
  type: typeof HISTORY_BACK
}

type RefreshPageType = {
  type: typeof REFRESH_PAGE
}

type ScrollIntoViewType = {
  type: typeof SCROLL_TO
}

export const historyBack = () => ({
  type: HISTORY_BACK
})

export const refreshPage = () => ({
  type: REFRESH_PAGE
})

export const refreshPageOnce = () => ({
  type: REFRESH_PAGE_ONCE
})

export const clearRefreshedStatus = () => ({
  type: CLEAR_REFRESHED_STATUS
})

export const scrollTo = (elementRef: string) => ({
  type: SCROLL_TO,
  elementRef
})

export const scrollToWindowTop = () => ({
  type: SCROLL_TO_WINDOW_TOP
})

export interface NavigateToSearch {
  isAuthenticated?: boolean
  isAudience?: boolean
  isNewTab?: boolean
  checkIn?: string
  checkOut?: string
  rooms?: string
  optimizeRooms?: string
  utm_source?: string
  utm_campaign?: string
  placeID?: string
  // bookingHint=1 (show date confirmation tooltip) is used to open the search box for mobile and date confirmation tooltip on desktop
  // it was added as part of this task: https://app.shortcut.com/findhotel/story/154347/update-landing-experience-for-users-with-no-dates-default-dates-widget-traffic
  bookingHint?: string
}

export const navigateToSearch = ({
  isAuthenticated,
  isAudience,
  isNewTab,
  checkIn,
  checkOut,
  rooms,
  optimizeRooms,
  utm_source,
  utm_campaign,
  placeID,
  bookingHint
}: NavigateToSearch) => ({
  type: NAVIGATE_TO_SEARCH,
  params: {
    isAuthenticated,
    isAudience,
    isNewTab,
    checkIn,
    checkOut,
    rooms,
    optimizeRooms,
    utm_source,
    utm_campaign,
    placeID,
    bookingHint
  }
})

export const setPpLoaded = createAction(PP_LOADED)

export type ModuleActionType =
  | HistoryBackType
  | RefreshPageType
  | ScrollIntoViewType
